import React from "react";

import { Stack, Typography, Divider, Box, Paper } from "@mui/material";
import emptyIcon from "../../assets/images/Icons/search-table.png";

export const CustomDetailsList = (props) => {
  const {
    columns,
    data,
    title,
    headerRightContent = null,
    marginBottom = "0px",
    style = {},
    emptyTableMessage,
    isEmpty = false,
  } = props;

  const prepareData = columns?.map((val) => {
    if (typeof val.accessor === "string") {
      return {
        ...val,
        accessor: data[val.accessor],
        hidden: val.hidden ? val.hidden(data) : false,
      };
    } else {
      return {
        ...val,
        accessor: val.accessor(data),
        hidden: val.hidden ? val.hidden(data) : false,
      };
    }
  });

  return (
    <Stack sx={{ mb: marginBottom, ...style }}>
      {title && (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          py="16px"
          height="54px"
        >
          <Typography
            variant="h6"
            fontWeight={600}
            lineHeight="19px"
            minWidth="160px"
          >
            {title}
          </Typography>
          {headerRightContent}
        </Stack>
      )}
      <Divider />
      {isEmpty ? (
        <Stack alignItems="center" gap="8px" py="32px">
          <img src={emptyIcon} alt="empty" height={56} width={56} />
          <Typography
            sx={{ fontWeight: 400, fontSize: "14px", color: "#485364" }}
          >
            {emptyTableMessage ? emptyTableMessage : "No matches found"}
          </Typography>
        </Stack>
      ) : (
        <Stack
          sx={{
            backgroundColor: "#F7FAFC",
            flexDirection: "row",
            p: "8px",
          }}
        >
          <Box>
            {prepareData?.map((data, index) => {
              return (
                <Stack
                  key={index}
                  minHeight="40px"
                  justifyContent="center"
                  p="8px"
                  sx={{ display: data.hidden ? "none" : "" }}
                >
                  <Typography
                    variant="subtitle2"
                    fontWeight={600}
                    minWidth="160px"
                  >
                    {data.title}
                  </Typography>
                </Stack>
              );
            })}
          </Box>

          <Stack
            component={Paper}
            elevation={0}
            sx={{
              width: "100%",
              border: "1px solid",
              borderColor: "divider",
              borderRadius: "4px",
            }}
          >
            {prepareData?.map((data, index) => {
              const lastItem = index === prepareData.length - 1;
              return (
                <Stack
                  ky={index}
                  minHeight="40px"
                  justifyContent="center"
                  p="8px"
                  width="100%"
                  borderBottom={lastItem ? 0 : "1px solid"}
                  borderColor="divider"
                  sx={{ display: data.hidden ? "none" : "" }}
                >
                  <Typography variant="subtitle2" fontWeight={400} color="#000">
                    {data.accessor}
                  </Typography>
                </Stack>
              );
            })}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};
